export default function PageInsetBottom() {
  return (
    <div style={{ height: 100 }} />
  );
}
